export default "__VITE_ASSET__DvI2mxYa__"